var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1668 28.5945L56.8683 50.2016C57.0178 50.7681 56.6824 51.3492 56.1171 51.503L51.2592 52.8251L51.1668 28.5945Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3206 51.4308L55.8371 50.4738L52.2654 36.9381L52.3206 51.4308ZM50.1003 28.5986L52.1983 28.3224L57.8998 49.9295C58.1988 51.0625 57.5279 52.2246 56.3973 52.5323L50.1979 54.2194L50.1003 28.5986Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4337 57.0667L21.0648 60.8927C20.5007 61.0429 19.9205 60.7117 19.7632 60.1494L18.9004 57.0667L35.4337 57.0667Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4941 56L35.4337 56L35.7081 58.0974L21.3392 61.9235C20.2109 62.2239 19.0506 61.5614 18.7359 60.4369L17.4941 56ZM20.3065 58.1333L20.7903 59.862L27.2823 58.1333L20.3065 58.1333Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06953 17.5374C6.91811 16.9688 7.2558 16.3849 7.8242 16.2326L12.767 14.9082L12.767 38.9333L7.06953 17.5374Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03853 17.8119C5.73569 16.6747 6.41107 15.5069 7.54788 15.2023L13.8334 13.5181L13.8334 38.9334L11.736 39.2078L6.03853 17.8119ZM11.7001 16.2983L8.10003 17.263L11.7001 30.7824L11.7001 16.2983Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7002 10.1333C11.7002 8.95513 12.6553 8 13.8335 8H50.1002C51.2784 8 52.2335 8.95513 52.2335 10.1333V56C52.2335 57.1782 51.2784 58.1333 50.1002 58.1333H13.8335C12.6553 58.1333 11.7002 57.1782 11.7002 56V10.1333ZM50.1002 10.1333H13.8335V56H50.1002V10.1333Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2334 19.2C20.2334 18.6109 20.711 18.1333 21.3001 18.1333H42.6334C43.2225 18.1333 43.7001 18.6109 43.7001 19.2C43.7001 19.7891 43.2225 20.2667 42.6334 20.2667H21.3001C20.711 20.2667 20.2334 19.7891 20.2334 19.2Z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2334 24.5333C20.2334 23.9442 20.711 23.4667 21.3001 23.4667H42.6334C43.2225 23.4667 43.7001 23.9442 43.7001 24.5333C43.7001 25.1224 43.2225 25.6 42.6334 25.6H21.3001C20.711 25.6 20.2334 25.1224 20.2334 24.5333Z",
    fill: "#E5E5E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2334 29.8667C20.2334 29.2776 20.711 28.8 21.3001 28.8H42.6334C43.2225 28.8 43.7001 29.2776 43.7001 29.8667C43.7001 30.4558 43.2225 30.9333 42.6334 30.9333H21.3001C20.711 30.9333 20.2334 30.4558 20.2334 29.8667Z",
    fill: "#E5E5E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2334 35.2C20.2334 34.6109 20.711 34.1333 21.3001 34.1333H42.6334C43.2225 34.1333 43.7001 34.6109 43.7001 35.2C43.7001 35.7891 43.2225 36.2667 42.6334 36.2667H21.3001C20.711 36.2667 20.2334 35.7891 20.2334 35.2Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2334 40.5333C20.2334 39.9442 20.711 39.4667 21.3001 39.4667H42.6334C43.2225 39.4667 43.7001 39.9442 43.7001 40.5333C43.7001 41.1224 43.2225 41.6 42.6334 41.6H21.3001C20.711 41.6 20.2334 41.1224 20.2334 40.5333Z",
    fill: "#E5E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2334 45.8667C20.2334 45.2776 20.711 44.8 21.3001 44.8L34.1001 44.8C34.6892 44.8 35.1667 45.2776 35.1667 45.8667C35.1667 46.4558 34.6892 46.9333 34.1001 46.9333L21.3001 46.9333C20.711 46.9333 20.2334 46.4558 20.2334 45.8667Z",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8538 9.91243C35.2704 10.329 35.2704 11.0044 34.8538 11.4209L32.1871 14.0876C31.7706 14.5041 31.0952 14.5041 30.6786 14.0876C30.2621 13.671 30.2621 12.9957 30.6786 12.5791L33.3453 9.91243C33.7619 9.49587 34.4372 9.49587 34.8538 9.91243Z",
    fill: "#E5E5E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9001 9.33334C38.9001 11.2479 37.3481 12.8 35.4335 12.8C33.5189 12.8 31.9668 11.2479 31.9668 9.33334C31.9668 7.41875 33.5189 5.86667 35.4335 5.86667C37.3481 5.86667 38.9001 7.41875 38.9001 9.33334Z",
    fill: "#F5F5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4337 6.93332C34.1082 6.93332 33.0337 8.00784 33.0337 9.33332C33.0337 10.6588 34.1082 11.7333 35.4337 11.7333C36.7592 11.7333 37.8337 10.6588 37.8337 9.33332C37.8337 8.00784 36.7592 6.93332 35.4337 6.93332ZM30.9004 9.33332C30.9004 6.82963 32.93 4.79999 35.4337 4.79999C37.9374 4.79999 39.9671 6.82963 39.9671 9.33332C39.9671 11.837 37.9374 13.8667 35.4337 13.8667C32.93 13.8667 30.9004 11.837 30.9004 9.33332Z",
    fill: "#E5E5E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0337 6.66667C41.0337 8.28671 39.7204 9.6 38.1003 9.6C36.4803 9.6 35.167 8.28671 35.167 6.66667C35.167 5.04664 36.4803 3.73334 38.1003 3.73334C39.7204 3.73334 41.0337 5.04664 41.0337 6.66667Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0996 4.79999C37.0687 4.79999 36.2329 5.63573 36.2329 6.66666C36.2329 7.69759 37.0687 8.53332 38.0996 8.53332C39.1305 8.53332 39.9663 7.69759 39.9663 6.66666C39.9663 5.63573 39.1305 4.79999 38.0996 4.79999ZM34.0996 6.66666C34.0996 4.45752 35.8905 2.66666 38.0996 2.66666C40.3087 2.66666 42.0996 4.45752 42.0996 6.66666C42.0996 8.8758 40.3087 10.6667 38.0996 10.6667C35.8905 10.6667 34.0996 8.8758 34.0996 6.66666Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.6963ef9326699541048f81b093b06094.svg";
export { ForwardRef as ReactComponent };